var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-generator-content"},[(!_vm.hasDefaultSlot)?_c('div',{staticClass:"empty-content-placeholder"},[(_vm.editing)?_c('span',[_vm._v("Belge İçeriği")]):_vm._e()]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }